import React from 'react'

//fallback components
export const DefaultHeader = () => <React.Fragment />
export const DefaultDialogContent = () => <span>no dialog</span>
